import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ForgotPasswordStateEnum} from '../../interfaces/ForgotPasswordStateEnum';
import {ActivatedRoute} from '@angular/router';
import {Select, Store} from '@ngxs/store';
import {RequestResetByEmail, ResetPassword, ValidatePasswordLink} from '../../../shared/states/auth/auth.actions';
import {take, withLatestFrom} from 'rxjs/operators';
import {GetUserPharmacies} from '../../../shared/states/pharmacy/pharmacy.actions';
import {CustomEmailValidator} from '../../../shared/validators/custom-email.validator';
import {StrongPasswordValidator} from '../../../shared/validators/strong-password.validator';
import {Observable} from 'rxjs';
import {AuthState} from 'src/app/shared/states/auth/auth.state';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss', './../../auth.scss'],
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: UntypedFormGroup;
  newPasswordForm: UntypedFormGroup;

  ForgotPasswordStateEnum = ForgotPasswordStateEnum;

  currentState: ForgotPasswordStateEnum;

  confirmationCode: string;
  confirmationEmail: string;
  showLinkErrors: boolean;
  showPasswordForm: boolean;

  @Select(AuthState.validatePasswordLinkResponse) validatePasswordLinkResponse$: Observable<any>;
  @Select(AuthState.loading) loading$: Observable<boolean | undefined>;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private store: Store,
  ) {
    this.resetPasswordForm = this.fb.group({
      email: ['', [Validators.required, CustomEmailValidator]],
    });

    this.newPasswordForm = this.fb.group({
      password: ['', [Validators.required, StrongPasswordValidator]],
    });
  }

  ngOnInit(): void {
    this.confirmationCode = this.route.snapshot.queryParams?.code;
    this.confirmationEmail = this.route.snapshot.queryParams?.username;
    this.currentState = this.confirmationCode ? ForgotPasswordStateEnum.ResetPassword : ForgotPasswordStateEnum.SendEmail;
    this.showLinkErrors = false;
    this.showPasswordForm = false;

    if (this.currentState === ForgotPasswordStateEnum.ResetPassword) {
      this.validatePasswordLink();
    }
  }

  sendEmail(): void {
    if (this.resetPasswordForm.valid) {
      this.store.dispatch(new RequestResetByEmail(this.resetPasswordForm.get('email').value))
        .pipe(take(1))
        .subscribe(() => {
          this.currentState = ForgotPasswordStateEnum.EmailIsSent;
        });
    }
  }

  sendPassword(): void {
    if (this.newPasswordForm.valid) {
      // TODO: check if confirmationCode and email exist
      this.store.dispatch(new ResetPassword({
        password: this.newPasswordForm.get('password')?.value,
        email: this.confirmationEmail,
        code: this.confirmationCode,
      }))
        .pipe(take(1))
        .subscribe(() => {
          this.currentState = ForgotPasswordStateEnum.PasswordIsReset;
          this.store.dispatch(new GetUserPharmacies());
        });
    }
  }

  validatePasswordLink(): void {
    this.store.dispatch(new ValidatePasswordLink(this.confirmationEmail, this.confirmationCode))
      .pipe(take(1), withLatestFrom(this.validatePasswordLinkResponse$))
      .subscribe(([_, response]) => {
        if (response && response === 'OK') {
          this.showLinkErrors = false;
          this.showPasswordForm = true;
        } else {
          this.showLinkErrors = true;
          this.showPasswordForm = false;
        }
      });
  }
}
